import { useQuery } from "react-query";
import axios from "axios";
import {useSelector } from "react-redux";
import {apiUrlSelector} from "../redux/selectors";

export const useMachinery = () => {
    
    const apiUrl = useSelector(apiUrlSelector);
    
    return useQuery(["machinery", apiUrl], () =>
        axios.get(`${apiUrl}machinery`).then(res => res.data.data),
        {
            refetchOnWindowFocus: false,
            placeholderData: []
        }
    );
};

export default useMachinery;